<template>
  <component
    :to="to"
    :is="type"
    :href="href"
    v-bind="$attrs"
    v-on="$listeners"
    class="button-box"
    :class="cssClasses"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "button-box",
  inheritAttrs: false,
  props: {
    to: Object,
    href: String,
    size: {
      type: String,
      default: null,
      validator: value => ["small"].includes(value)
    },
    work: {
      type: Boolean,
      default: false
    },
    outline: {
      type: [Boolean, String],
      default: false,
      validator: value => [true, false, "white", "fill"].includes(value)
    }
  },
  computed: {
    type() {
      if (this.to) return "router-link";
      if (this.href) return "a";
      return "button";
    },
    cssClasses() {
      return {
        "button-box--small": this.size === "small",
        "button-box--outlined": this.outline === true,
        "button-box--white": this.outline === "white",
        "button-box--fill": this.outline === "fill",
        "to-work": this.work === true
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars.scss";

.button-box {
  --fg-color: #fff;
  --bg-color: #ff3c3c;

  font-size: 1.9rem;
  font-weight: 700;
  line-height: 1.2;

  display: inline-block;

  min-width: 30rem;
  padding: 1.7rem 2rem 1.6rem;

  cursor: pointer;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;

  color: var(--fg-color);
  border: 1px solid var(--bg-color);
  border-radius: 0.8rem;
  background-color: var(--bg-color);

  @media (max-width: $max-sm) {
    font-size: 1.5rem;

    width: 100%;
    min-width: auto;
    padding: 1.2rem 1rem 1.1rem;
  }

  &--small {
    @media (max-width: $max-sm) {
      width: auto;
      padding: 0.5rem 2rem;
    }
  }

  &--outlined {
    color: var(--bg-color);
    border-color: var(--bg-color);
    background-color: transparent;
  }

  &--white {
    color: #fff;
    border-color: var(--bg-color);
    background-color: transparent;
  }

  &--fill {
    color: var(--bg-color);
    border-color: var(--bg-color);
    background-color: #fff;
  }

  &[disabled] {
    --bg-color: #ccc;
  }
}

.to-work {
  margin-left: 35%;
  justify-content: center;
  margin-bottom: 10rem;
}
</style>
